import { withSvgIcon } from './withSvgIcon';

export const NavBarTeams = withSvgIcon(
  <>
    <circle cx="8.5" cy="6" r="3" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="15.5" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M8.5 13H4.5C3.39543 13 2.5 13.8954 2.5 15V16" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M9.5 22V21C9.5 19.8954 10.3954 19 11.5 19H19.5C20.6046 19 21.5 19.8954 21.5 21V22" stroke="currentColor" strokeWidth="1.5"/>
  </>,
  { viewBox: '0 0 24 24' },
);
